// Cookie notice for the signed-out site: shown until accepted; "Later" hides it for 5 minutes.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './cookieBar.css';

const LATER_MS = 5 * 60 * 1000;

const readDelay = () => {
  try {
    if (localStorage.getItem('cookieConsent') === 'accepted') return null;
    const later = Number(localStorage.getItem('laterTime'));
    if (localStorage.getItem('cookieConsent') === 'later' && later) return Math.max(LATER_MS - (Date.now() - later), 0);
  } catch {}
  return 0;
};

const CookieBar = () => {
  const [show, setShow] = useState(false);

  // Appears after a short pause (or once a "Later" has run out), never over the first paint
  const [delay, setDelay] = useState(readDelay);
  useEffect(() => {
    if (delay === null) return undefined;
    const timer = setTimeout(() => setShow(true), Math.max(delay, 2000));
    return () => clearTimeout(timer);
  }, [delay]);

  const accept = () => {
    try { localStorage.setItem('cookieConsent', 'accepted'); } catch {}
    setShow(false);
    setDelay(null);
  };

  const later = () => {
    try {
      localStorage.setItem('cookieConsent', 'later');
      localStorage.setItem('laterTime', String(Date.now()));
    } catch {}
    setShow(false);
    setDelay(LATER_MS);
  };

  if (!show) return null;
  return (
    <div className="mkc" role="region" aria-label="Cookie notice">
      <p className="mkc-text">
        Our website uses cookies. By continuing, we assume your permission to deploy cookies as detailed in
        our <Link to="/privacy-policy">Privacy Policy</Link>.
      </p>
      <div className="mkc-actions">
        <button type="button" className="mkc-btn" onClick={later}>Later</button>
        <button type="button" className="mkc-btn mkc-btn--primary" onClick={accept}>Accept</button>
      </div>
    </div>
  );
};

export default CookieBar;
